//format date string - if user's address is in China or US, it will display a relevant date format.  
//Otherwise, displays GB date format
export const processDate = (date: Date): string => {
    if (date) {
        const userCountry = sessionStorage.getItem('_UserCountryCode');
        let formattedDate = '';
        const newDate = new Date(date);
        switch (userCountry) {
            case 'US':
            case 'USA':
                formattedDate = newDate.toLocaleDateString('en-US');
                break;
            case 'CN':
            case 'CNA':
                formattedDate = newDate.toLocaleDateString('zh-Hans-CN');
                break;
            default:
                formattedDate = newDate.toLocaleDateString('en-GB');
                break;
        }

        return formattedDate;
    }

    return date;
    
}